<template>
  <div id="app home">
    <div v-if="!loaded || !loadedChars" class="loader">
      <div class="loading loading-lg"></div>
    </div>

    <template v-else>
      <div class="scroll-top" @click="scrollToTop">(^)</div>

      <div class="toast">
        <P
          >Prompts are final as of the close of signups. If mods remove/amend signups, there may be
          changes. Please post a
          <a href="https://karanguni.dreamwidth.org/290563.html">bug report</a> if there are
          problems.</P
        >

        <p>
          All requests are also available as a
          <a
            href="https://docs.google.com/spreadsheets/d/1W7bq-xFxgYqoGWOT7zNaLgKs-B1kNewot0SDlsB24tM/edit?usp=sharing"
            >Google spreadsheet</a
          >.
        </p>
      </div>
      <options></options>
      <pagination :options="options" :pagination="pagination" @page="page"></pagination>

      <div v-if="updating" class="loader">
        <div class="loading loading-lg"></div>
      </div>

      <table class="main" v-if="!updating">
        <thead>
          <tr>
            <th class="fandom">Fandom</th>
            <th class="characters" v-if="!options.hideCharacters">
              Relationships
            </th>
            <th v-if="unlock || isModIn" class="prompts">
              Requests
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(fandom, index) in filtered"
            :key="fandom['.key']"
            :class="{ odd: index % 2 !== 0 }"
          >
            <td class="fandom" data-label="Fandom">
              <router-link :to="`/fandom/${fandom['.key']}`">{{ fandom.name }}</router-link
              >&nbsp;
              <button class="bookmark" @click="toggle(fandom)">
                <span v-if="hasBookmark(fandom)" class="fas fa-heart"></span>
                <span v-else class="far fa-heart"></span>
              </button>
              <div class="meta">
                <span class="category meta-tag" v-if="!options.hideCategory">{{
                  fandom.category.join(", ")
                }}</span>
              </div>
            </td>
            <td class="characters" v-if="!options.hideCharacters">
              <ul>
                <li
                  v-for="char in getCharacters(fandom['.key'])"
                  :class="{ highlight: letterChars && letterHasChar(fandom['.key'], char) }"
                  :key="char"
                >
                  {{ char }}
                </li>
              </ul>
            </td>
            <td v-if="unlock || isModIn" class="prompts">
              <button
                class="btn btn-primary"
                v-if="!prompts[fandom['.key']] && hasPrompts[fandom['.key']]"
                @click="getPrompts(fandom['.key'])"
              >
                Get Prompts
              </button>
              <div v-if="prompts[fandom['.key']] === 'loading'" class="loading"></div>

              <keep-alive>
                <component
                  :is="tableComponent"
                  :prompts="prompts[fandom['.key']]"
                  v-if="
                    prompts[fandom['.key']] &&
                      prompts[fandom['.key']].length &&
                      prompts[fandom['.key']] !== 'loading'
                  "
                ></component>
                <span v-else-if="!hasPrompts[fandom['.key']]">No prompts ):</span>
              </keep-alive>
            </td>
          </tr>
        </tbody>
      </table>

      <pagination :options="options" :pagination="pagination" @page="page"></pagination>
    </template>
  </div>
</template>

<script>
import Options from "../components/options.vue";
import PromptTable from "../components/promptTable.vue";
import PromptTableTwo from "../components/promptTableTwo.vue";
import Pagination from "../components/pagination.vue";
import utils from "../components/utils.js";
// third party
import { filter, slice, sortBy, each, includes } from "lodash-es";
import { mapGetters } from "vuex";
import axios from "axios";
// Remove english articles from fandom names
function removeArticlesCompare(o) {
  if (!o) {
    return;
  }
  const regex = /^(the\s|a\s|an\s)/i;
  if (!o.name) {
    return o;
  }
  return o.name.toLowerCase().replace(regex, "");
}

export default {
  name: "app",
  components: {
    Pagination,
    Options
  },
  beforeMount() {
    axios.get(`https://chocobox2020.firebaseio.com/letterkeys.json?shallow=true`).then(res => {
      this.totalLetters = res.data ? Object.keys(res.data).length : 0;
    });
    axios.get(`https://chocobox2020.firebaseio.com/timestamp.json`).then(res => {
      this.timestamp = res.data.timestamp;
    });
  },
  created() {
    this.updateFilter();
  },
  data() {
    return {
      totalLetters: 0,
      lastLetterUpdate: new Date(),
      tableComponent: PromptTable,
      maintenance: false,
      timestamp: null,
      showEggHelp: false,
      showHelp: false,
      down: {},
      mods: false,
      // scrollPosition: 100,
      filtered: [],
      updating: true,
      sticky: false,
      letterChars: {
        fandom: "",
        characters: []
      },
      promptStates: {},
      pagination: {
        first: 0,
        last: 100,
        size: 100,
        total: 0
      }
    };
  },
  computed: {
    ...mapGetters([
      "isModIn",
      "bookmarks",
      "lettermarks",
      "categories",
      "characters",
      "fandoms",
      "hasPrompts",
      "letters",
      "loadAll",
      "loaded",
      "loadedChars",
      "loadedHasPrompts",
      "options",
      "promptmarks",
      "prompts",
      "unlock",
      "user"
    ])
  },
  watch: {
    async $route(to) {
      if (to.name === "home") {
        axios
          .get(`https://chocobox2020.firebaseio.com/letterkeys.json?shallow=true`)
          .then(async res => {
            if (Object.keys(res.data) && Object.keys(res.data).length !== this.totalLetters) {
              this.totalLetters = Object.keys(res.data).length;
              axios.get(`https://chocobox2020.firebaseio.com/letters.json`).then(res => {
                this.$store.commit("setLetters", res.data);
              });
            }
          });
      }
    },
    fandoms() {
      this.pagination.first = 0;
      this.pagination.last = this.pagination.size;
      this.updateFilter();
    },
    // Deep watching doesn't work
    // Reset pagination when the filters change
    "options.filter.term": function() {
      this.updateFilter(true);
    },
    "options.filter.category": function() {
      this.updateFilter(true);
    },
    "options.onlyBookmarks": function(val) {
      this.updateFilter(true);
    },
    "options.onlyPrompts": function() {
      this.updateFilter(true);
    },
    "options.tableStyle": function(val) {
      switch (val) {
        case "split":
          this.tableComponent = PromptTable;
          break;
        case "combined":
          this.tableComponent = PromptTableTwo;
          break;
        default:
          this.tableComponent = PromptTable;
          break;
      }
    },
    "options.loadAll": async function(val) {
      if (val && !this.loadAll.characters) {
        window.gtag("event", "category", {
          event_category: "loadall"
        });
        this.updating = true;
        await axios
          .get(`https://chocobox2020.firebaseio.com/characters.json?orderBy="$key"`)
          .then(res => {
            this.$store.commit("loadAllChars", true);
            this.$store.commit("setCharacters", res.data);
          });
      } else if (!val) {
        this.pagination.last = this.pagination.size;
      }
      this.updateFilter();
    },
    loaded() {
      this.updateFilter();
    }
  },
  methods: {
    ...utils,
    updateFilter(resetPagination) {
      this.updating = true;

      if (resetPagination) {
        this.pagination.first = 0;
        this.pagination.last = this.pagination.size;
      }

      // Do not let pagination go below 0
      if (this.pagination.first < 0) {
        this.pagination.first = 0;
      }

      // When loadAll is turned on, always page all the way
      if (this.options.loadAll) {
        this.pagination.first = 0;
        this.pagination.last = this.fandoms.length;
      }

      // Remove fandoms that have no names
      let arr = filter(this.fandoms, f => {
        return f.name.length;
      });

      // Case: no filters
      // Show all fandoms, slicing by pagination
      if (
        !this.options.onlyPrompts &&
        !this.options.filter.term.length &&
        !this.options.onlyBookmarks &&
        !this.options.onlyLetters &&
        !this.options.onlyPHs &&
        !this.options.filter.category.length
      ) {
        this.filtered = slice(
          sortBy(arr, ["category", removeArticlesCompare]),
          this.pagination.first,
          this.pagination.last
        );

        this.pagination.total = arr.length;

        setTimeout(() => {
          this.updating = false;
        }, 150);

        return;
      }

      // Case: apply filters

      if (this.options.onlyPrompts && this.hasPrompts && this.hasPrompts.length) {
        arr = filter(arr, o => {
          return this.hasPrompts[o[".key"]];
        });
      }

      if (this.options.onlyBookmarks) {
        const bookmarkedFandoms = [];
        each(this.bookmarks, b => {
          bookmarkedFandoms.push(b.name);
        });

        arr = filter(arr, o => {
          return includes(bookmarkedFandoms, o.name);
        });
      }

      if (this.options.onlyLetters) {
        if (!this.letters) {
          arr = [];
        } else {
          arr = filter(arr, o => {
            return this.letters[o[".key"]];
          });
        }
      }

      if (this.options.filter.category.length) {
        arr = filter(arr, o => {
          return includes(o.category, this.options.filter.category);
        });
      }

      if (this.options.filter.term.length) {
        arr = filter(arr, o => {
          const name = o.name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          return name.indexOf(this.options.filter.term.toLowerCase()) > -1;
        });
      }

      // Set pagination.last if the filtered array ends up being smaller
      // or if loadAll is turned on
      if (arr.length < this.pagination.last || this.options.loadAll) {
        this.pagination.last = arr.length;
      }

      // Slice search word and category filters by name without
      // regard for category
      if (this.options.filter.term.length || this.options.filter.category.length) {
        this.filtered = slice(
          sortBy(arr, [removeArticlesCompare]),
          this.pagination.first,
          this.pagination.last
        );

        this.pagination.total = arr.length;

        // Categories and search words return such an array of fandoms
        // with varied indices that it's a better idea to just load
        // all characters than risk 100000 requests
        if (!this.loadAll.characters) {
          axios
            .get(`https://chocobox2020.firebaseio.com/characters.json?orderBy="$key"`)
            .then(res => {
              const backFill = res.data;
              const newVal = { ...this.characters, ...backFill };
              this.$store.commit("loadAllChars", true);
              this.$store.commit("setCharacters", {});
              this.$store.commit("setCharacters", newVal);
              this.updating = false;
            });
        } else {
          setTimeout(() => {
            this.updating = false;
          }, 100);
        }

        return;
      }

      // Otherwise, sort by category before slicing
      this.filtered = slice(
        sortBy(arr, ["category", removeArticlesCompare]),
        this.pagination.first,
        this.pagination.last
      );
      this.pagination.total = arr.length;

      // If too many character lists are missing, load everything
      if (
        this.filtered[this.filtered.length - 1] &&
        this.filtered[this.filtered.length - 1][".key"] - this.pagination.last > 10 &&
        !this.loadAll.characters
      ) {
        axios
          .get(`https://chocobox2020.firebaseio.com/characters.json?orderBy="$key"`)
          .then(res => {
            const backFill = res.data;
            const newVal = { ...this.characters, ...backFill };
            this.$store.commit("loadAllChars", true);
            this.$store.commit("setCharacters", {});
            this.$store.commit("setCharacters", newVal);
          });

        setTimeout(() => {
          this.updating = false;
        }, 100);
      }

      setTimeout(() => {
        this.updating = false;
      }, 100);
    },
    async page(start) {
      this.pagination.last = start + this.pagination.size;
      this.pagination.first = start;

      // load a whole bunch at once to save on i/o
      if (!this.characters[this.pagination.first + 50] || !this.characters[this.pagination.last]) {
        await axios
          .get(
            `https://chocobox2020.firebaseio.com/characters.json?orderBy="$key"&startAt="${this.pagination.first}"&endAt="${this.pagination.last}"`
          )
          .then(res => {
            const backFill = res.data;
            const newVal = { ...this.characters, ...backFill };
            this.$store.commit("setCharacters", {});
            this.$store.commit("setCharacters", newVal);
          });
      }
      this.updateFilter();
    },

    // unlockModTools(e) {
    //   if (e.type === "keydown") {
    //     this.down[e.keyCode] = true;

    //     // shift + 1 + 2
    //     if (this.down[16] && this.down[49] && this.down[50]) {
    //       this.mods = !this.mods;
    //     }
    //   }

    //   if (e.type === "keyup") {
    //     this.down[e.keyCode] = false;
    //   }
    // },
    // // show easter eggs on F1
    // easterEggs(e) {
    //   if (e.keyCode !== 112) {
    //     return;
    //   }

    //   this.$store.commit("setEggs", !this.showEasterEggs);
    //   this.showEggHelp = true;
    // },
    // utilities
    scrollToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style lang="scss">
@import "../styles/app.scss";
@import "../styles/mobile.scss";
</style>
